import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

export const authGuard = () => {
  const authService = inject(LoginService);
  const router = inject(Router);

  if (!authService.currentUser || authService.currentUser.UserId < 1) {
    authService.getCurrentUser();
  }

  let isSessionValidated = authService.validateSession();

  if (authService.currentUser && authService.currentUser.UserId > 0 && isSessionValidated === true) {
    return true;
  }
  else {
    router.navigateByUrl("signin");
    return false;
  }
};
